<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Chats' : 'Deleted Chats'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/chats/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search chats..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="chatType"
                    v-model="filter.is_group"
                    :items="chatTypes"
                    label="Chat Type"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-message"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="deletedStatus"
                    solo
                    rounded
                    v-model="filter.show_deleted"
                    :items="deletedStatuses"
                    label="Show"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-eye"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="chats.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Type</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Image</th>
                      <th class="text-left">Created By</th>
                      <th class="text-left">Created At</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="chats.length != 0">
                    <tr v-for="(chat, i) in chats" :key="`chat${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="chat.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Chat is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="chat.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Chat is Inactive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              :color="chat.is_group ? 'blue' : 'purple'"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">
                                  {{ chat.is_group ? 'mdi-account-group' : 'mdi-account' }}
                                </v-icon>
                              </v-avatar>
                              {{ chat.is_group ? 'Group' : 'Direct' }}
                            </v-chip>
                          </template>
                          <span>{{ chat.is_group ? 'Group Chat' : 'Direct Chat' }}</span>
                        </v-tooltip>
                      </td>
                      <td>{{ chat.name || 'Direct Chat' }}</td>
                      <td>
                        <v-avatar size="30" v-if="chat.image_path">
                          <v-img :src="chat.image_path" alt="Chat Image"></v-img>
                        </v-avatar>
                        <v-icon v-else color="grey">mdi-image-off</v-icon>
                      </td>
                      <td>
                        {{ chat.created_by ? chat.created_by.user_name : 'N/A' }}
                      </td>
                      <td>{{ formatDate(chat.created_at) }}</td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="primary"
                                @click="openChat(chat.id)"
                              >
                                <v-icon dark> mdi-message </v-icon>
                              </v-btn>
                            </template>
                            <span>Open chat conversation</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto mx-1"
                                color="success"
                                :to="`/chats/${chat.id}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this chat</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto mx-1"
                                color="error"
                                @click="Delete_this(chat.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this chat</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="success"
                                @click="Restore_this(chat.id)"
                              >
                                <v-icon dark> mdi-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this chat</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">
                        <div style="height: 200px">
                          <div class="mt-5">
                            <v-icon size="100" color="grey lighten-1">
                              mdi-message-outline
                            </v-icon>
                            <p class="mt-5 subtitle-1 grey--text">
                              {{ !chats.length ? 'No chats available' : '' }}
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Pagination -->
      <v-row v-if="chats.length != 0">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <v-row align="center">
                <v-col sm="2">
                  <v-autocomplete
                    ref="rowsPerPage"
                    solo
                    rounded
                    v-model="rowsPerPage"
                    :items="rowsPerPageArray"
                    label="Rows per page"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-table"
                  ></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
                <v-col sm="6">
                  <v-pagination
                    v-model="page"
                    :length="Math.ceil(count / rowsPerPage)"
                    :total-visible="5"
                    @input="getData()"
                    color="primary"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";

export default {
  name: "ChatListPage",
  data() {
    return {
      chats: [],
      isLoading: true,
      isExcelloading: false,
      page: 1,
      count: 0,
      rowsPerPage: 10,
      rowsPerPageArray: [5, 10, 15, 20, 25, 30],
      filter: {
        search_keyword: null,
        is_group: null,
        is_active: null,
        show_deleted: null,
      },
      chatTypes: [
        { text: "Group Chat", value: true },
        { text: "Direct Chat", value: false },
      ],
      statuses: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      deletedStatuses: [
        { text: "Active Chats", value: false },
        { text: "Deleted Chats", value: true },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const params = {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          ...this.filter,
        };

        // Remove null values
        Object.keys(params).forEach((key) => {
          if (params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });

        const response = await axios.get("/chats", { params });

        if (response.data.success) {
          this.chats = response.data.data;
          this.count = response.data.count;
        } else {
          this.$store.dispatch("errors/setError", {
            message: response.data.message || "Failed to fetch chats",
          });
        }
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          this.$router.push("/login");
        } else {
          this.$store.dispatch("errors/setError", {
            message: "Error loading chats data",
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    async Delete_this(id) {
      if (confirm("Are you sure you want to delete this chat?")) {
        try {
          const response = await axios.post(`/chats/delete/${id}`);

          if (response.data.success) {
            this.$store.dispatch("errors/setSuccess", {
              message: "Chat deleted successfully",
            });
            this.getData();
          } else {
            this.$store.dispatch("errors/setError", {
              message: response.data.message || "Failed to delete chat",
            });
          }
        } catch (error) {
          console.error(error);
          this.$store.dispatch("errors/setError", {
            message: "Error deleting chat",
          });
        }
      }
    },

    async Restore_this(id) {
      if (confirm("Are you sure you want to restore this chat?")) {
        try {
          const response = await axios.post(`/chats/restore/${id}`);

          if (response.data.success) {
            this.$store.dispatch("errors/setSuccess", {
              message: "Chat restored successfully",
            });
            this.getData();
          } else {
            this.$store.dispatch("errors/setError", {
              message: response.data.message || "Failed to restore chat",
            });
          }
        } catch (error) {
          console.error(error);
          this.$store.dispatch("errors/setError", {
            message: "Error restoring chat",
          });
        }
      }
    },

    async generateExcel() {
      this.isExcelloading = true;
      try {
        const params = { ...this.filter };
        
        // Remove null values
        Object.keys(params).forEach((key) => {
          if (params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });

        const response = await axios.get("/chats/excel", {
          params,
          responseType: "blob",
        });

        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const fileName = `chats_export_${new Date().toISOString().split('T')[0]}.xlsx`;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.$store.dispatch("errors/setSuccess", {
          message: "Excel file generated successfully",
        });
      } catch (error) {
        console.error(error);
        this.$store.dispatch("errors/setError", {
          message: "Error generating Excel file",
        });
      } finally {
        this.isExcelloading = false;
      }
    },

    isDeletePage() {
      return this.filter.show_deleted === true;
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },

    openChat(chatId) {
      // Navigate to the chat interface with the specific chat ID
      this.$router.push(`/chat/${chatId}`);
    },
  },
};
</script>

<style scoped>
.action_th {
  min-width: 120px !important;
}

.striped-table {
  background: transparent;
}

.striped-table tr:nth-child(even) {
  background-color: #f5f5f5;
}

.v-card-title h3 {
  font-size: 1.5rem;
}
</style>